// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos adicionales para el nuevo formulario con catálogos */

.loading-catalogs {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font-size: 18px;
  color: #6b7280;
}

.employee-badge,
.machinery-badge {
  display: inline-block;
  margin-left: 10px;
  padding: 4px 10px;
  background: #e0f2fe;
  color: #0369a1;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.machinery-badge {
  background: #fef3c7;
  color: #92400e;
}

.alert {
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 15px;
  border-left: 4px solid;
}

.alert-warning {
  background: #fef3c7;
  border-color: #f59e0b;
  color: #92400e;
}

.alert-warning a {
  color: #0369a1;
  text-decoration: underline;
  font-weight: 600;
}

.alert-warning a:hover {
  color: #075985;
}

.help-text {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #6b7280;
  font-style: italic;
}

.readonly {
  background: #f3f4f6;
  cursor: not-allowed;
  color: #6b7280;
}

.info-text {
  padding: 15px;
  background: #e0f2fe;
  border-left: 4px solid #0369a1;
  border-radius: 4px;
  color: #075985;
  margin: 20px 0;
}

/* Mejoras para los selects */
.form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 18px;
  padding-right: 35px;
}

/* Responsive para badges */
@media (max-width: 768px) {
  .employee-badge,
  .machinery-badge {
    display: block;
    margin-left: 0;
    margin-top: 5px;
    width: fit-content;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/project/WorkReportFormNew.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,yDAA2R;EAC3R,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;;IAEE,cAAc;IACd,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":["/* Estilos adicionales para el nuevo formulario con catálogos */\r\n\r\n.loading-catalogs {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 400px;\r\n  font-size: 18px;\r\n  color: #6b7280;\r\n}\r\n\r\n.employee-badge,\r\n.machinery-badge {\r\n  display: inline-block;\r\n  margin-left: 10px;\r\n  padding: 4px 10px;\r\n  background: #e0f2fe;\r\n  color: #0369a1;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.machinery-badge {\r\n  background: #fef3c7;\r\n  color: #92400e;\r\n}\r\n\r\n.alert {\r\n  padding: 12px 16px;\r\n  border-radius: 6px;\r\n  margin-bottom: 15px;\r\n  border-left: 4px solid;\r\n}\r\n\r\n.alert-warning {\r\n  background: #fef3c7;\r\n  border-color: #f59e0b;\r\n  color: #92400e;\r\n}\r\n\r\n.alert-warning a {\r\n  color: #0369a1;\r\n  text-decoration: underline;\r\n  font-weight: 600;\r\n}\r\n\r\n.alert-warning a:hover {\r\n  color: #075985;\r\n}\r\n\r\n.help-text {\r\n  display: block;\r\n  margin-top: 4px;\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n  font-style: italic;\r\n}\r\n\r\n.readonly {\r\n  background: #f3f4f6;\r\n  cursor: not-allowed;\r\n  color: #6b7280;\r\n}\r\n\r\n.info-text {\r\n  padding: 15px;\r\n  background: #e0f2fe;\r\n  border-left: 4px solid #0369a1;\r\n  border-radius: 4px;\r\n  color: #075985;\r\n  margin: 20px 0;\r\n}\r\n\r\n/* Mejoras para los selects */\r\n.form-group select {\r\n  appearance: none;\r\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\r\n  background-repeat: no-repeat;\r\n  background-position: right 10px center;\r\n  background-size: 18px;\r\n  padding-right: 35px;\r\n}\r\n\r\n/* Responsive para badges */\r\n@media (max-width: 768px) {\r\n  .employee-badge,\r\n  .machinery-badge {\r\n    display: block;\r\n    margin-left: 0;\r\n    margin-top: 5px;\r\n    width: fit-content;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
